const styles = (theme) => ({
  indicator: {
    backgroundColor: theme.color.black,
    height: 4,
  },

  scroller: {
    padding: theme.spacing(0, 1.25),
  },

  appBarRoot: {
    background: 'transparent',
    boxShadow: 'none',
    zIndex: 99,
  },

  appBarRootFixed: {
    background: 'transparent',
    boxShadow: 'none',
    zIndex: 99,
    transform: 'none',

    '& .MuiTabs-root': {
      position: 'fixed',
      left: 0,
      right: 0,
      top: 52,
      height: 48,
      maxWidth: theme.breakpoints.values.sm,
      margin: '0 auto',
      borderBottom: `1px solid ${theme.color.grey_d3}`,
      zIndex: 11,
    },
  },

  tabRoot: {
    fontSize: 14,
    letterSpacing: 0.7,
    fontWeight: 'bold',
    padding: 0,
    minWidth: 'auto',
    margin: theme.spacing(0, 1.25),
  },

  divider: {
    marginBottom: theme.spacing(1),
  },
});

export default styles;
